import React, { createContext, useReducer, useContext } from 'react';
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "./constant";


const initialState = {
  loading: false,
  data: null,
  error: null
};


function buyerReducer(state, action){
  switch(action.type){
    case 'GET_BUYERS':
      return {
        ...state,
        loading : true,
      };
    case 'GET_BUYERS_SUCCESS':
      return {
        ...state,
        data: action.data,
        loading : false,
      };
    case 'GET_BUYERS_ERROR':
      return {
        ...state,
        error: action.error,
        loading : false,
      };
    default:
      throw new Error(`Unhanded action type: ${action.type}`);
  }
}


const BuyerStateContext = createContext(null);
const BuyerDispatchContext = createContext(null);



export function BuyersProvider({ children }) {
  const [state, dispatch] = useReducer(buyerReducer, initialState);
  return (
    <BuyerStateContext.Provider value={state}>
      <BuyerDispatchContext.Provider value={dispatch}>
        {children}
      </BuyerDispatchContext.Provider>
    </BuyerStateContext.Provider>
  );
}

export function useBuyersState() {
  const state = useContext(BuyerStateContext);
  if (!state) {
    throw new Error('Cannot find BuyerStateContext');
  }
  return state;
}

// Dispatch 를 쉽게 사용 할 수 있게 해주는 커스텀 Hook
export function useBuyersDispatch() {
  const dispatch = useContext(BuyerDispatchContext);
  if (!dispatch) {
    throw new Error('Cannot find BuyerDispatchContext');
  }
  return dispatch;
}


export async function getBuyers(dispatch) {


  dispatch({ type: 'GET_BUYERS' });

  try {
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/buyer?token=${cookie.load(RECEIVER_COOKIE_KEY)}`)
    if(response.status === 200 && response.data != null && response.data['code'] === 200){
      dispatch({ type: 'GET_BUYERS_SUCCESS', data: response.data['results'] });

    }else{
      dispatch({ type: 'GET_BUYERS_ERROR', error: 'cannot access to server' });
    }

  } catch (e) {
    dispatch({ type: 'GET_BUYERS_ERROR', error: e });
  }
}
